import { render, staticRenderFns } from "./products-select-category.vue?vue&type=template&id=614f5868&"
import script from "./products-select-category.vue?vue&type=script&lang=js&"
export * from "./products-select-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports